import type { PokerRank } from './PokerRank';

export const pokerRanksByStrength: PokerRank[] = [
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  'T',
  'J',
  'Q',
  'K',
  'A',
];
